import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LogoHeaderComponent } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { ProfileSelectorHeaderContent } from './models/profile-selector-header.interface';
@Component({
  selector: 'idp-profile-selector-header',
  standalone: true,
  templateUrl: './profile-selector-header.component.html',
  styleUrls: ['./profile-selector-header.component.scss'],
  imports: [CommonModule, LogoHeaderComponent]
})
export class ProfileSelectorHeaderComponent {
  @Input() profileHeaderContent = {} as ProfileSelectorHeaderContent;
  @Input() enableMachCoreProfileSelector = false;
}
